import axios from "@/api/axios";

const API_URL = process.env.VUE_APP_API_HOST;

/**
 * @param {Object} params
 * @param {number} params.page
 * @param {number} params.perPage
 * @param {string} params.searchQuery
 * @param {AbortSignal} params.signal
 */
export async function getCorporateGroupsApi({
  // page = 1,
  // perPage = 15,
  // searchQuery = "",
  signal = null,
  userRole = "",
}) {
  return await axios.get(`${API_URL}/api/admin/corporate-groups`, {
    params: {
      not_paginated: true,
      reduced: true,
      user_role: userRole,
    },
    signal,
  });
}
